import {
  page_default
} from "../chunk-4BBPNKUZ.js";
export {
  page_default as default
};
//# sourceMappingURL=page.js.map
